export default __webpack_public_path__ + "static/Inter-ExtraBold-03866a58a5ca4c09f33736ba57aaf63e.woff2";